import { useEffect, useRef, useState } from 'react'
import { Calendar, ConfigProvider } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import enUS from 'antd/locale/en_US'
import { IEvent} from '../../../types'

interface IMonthlyCalendarMobileProps {
  currentDate: Dayjs
  events: IEvent[]
  onOpenDetail?: (date: Date, events: IEvent[]) => void
  onOpenCreate?: (date: Date) => void
  onEventDetail?: (event: IEvent) => void
  loading?: boolean
  onSelectDate?: (date: Dayjs) => void
  selectedDate?: Dayjs
}

const MonthlyCalendarMobile = ({
  currentDate,
  events,
  onSelectDate,
  selectedDate,
}: IMonthlyCalendarMobileProps) => {
  const calendarRef = useRef<HTMLDivElement>(null);
  const [displayedMonth, setDisplayedMonth] = useState<Dayjs>(currentDate);

  useEffect(() => {
    setDisplayedMonth(currentDate);
  }, [currentDate]);

  useEffect(() => {
    if (!calendarRef.current) return;
    // Tìm tất cả các tr trong calendar
    const trs = calendarRef.current.querySelectorAll('tr');
    trs.forEach(tr => {
      const divs = tr.querySelectorAll('td > div');
      const allSelectNone = Array.from(divs).every(div => div.classList.contains('select-none'));
      if (divs.length > 0 && allSelectNone) {
        tr.remove();
      }
    });
  }, [displayedMonth, events]);

  return (
    <ConfigProvider locale={enUS}>
      <div ref={calendarRef}>
        <Calendar
          className='monthly-calendar__mobile'
          value={currentDate}
          onSelect={(date) => onSelectDate?.(date)}
          onPanelChange={(date) => setDisplayedMonth(date)}
          dateFullCellRender={(date: Dayjs) => {
            const day = date.date();
            const isToday = dayjs().isSame(date, 'day');
            const isSelected = selectedDate?.isSame(date, 'day') || false;
            const isCurrentMonth = date.month() === displayedMonth.month() && date.year() === displayedMonth.year();

            // Check if this date has events
            const hasEvents = events.some(event =>
              dayjs(event.startDate).isSame(date, 'day')
            );

            if (!isCurrentMonth) {
              // Ẩn ngày không thuộc tháng hiện tại
              return <div className="pointer-events-none select-none" />;
            }

            return (
              <div
                className="custom-date-cell cursor-pointer"
                onClick={() => onSelectDate?.(date)}
                style={{
                  display: 'flex',
                  height: '34px',
                  borderRadius: '50%',
                  width: '100%',
                  flexDirection: 'column',
                  gap: '2px',
                  alignItems: 'center',
                  justifyContent: 'start',
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    borderRadius: '100px',
                    background: isSelected ? '#FFF1CC' : '',
                    color: isToday ? '#FFB700' : isSelected ? '#FFB700' : '#1F2937',
                    width: '28px',
                    height: '28px',
                    padding: '4px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '12px',
                    lineHeight: '22px',
                  }}
                >
                  {day.toString().padStart(2, '0')}
                </div>
                {hasEvents && (
                  <div
                    style={{
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      backgroundColor: '#FFB700',
                    }}
                  />
                )}
              </div>
            );
          }}
          fullscreen={true}
        />
      </div>
    </ConfigProvider>
  );
}

export default MonthlyCalendarMobile;
